module.exports = __webpack_public_path__ + "img/creditos.ece06796.png";